<template>
  <div>
    <div class="subPanel">
      <button class="expandPanel" @click="collapse">
        <p
          :class="{
            changeExpand: !(
              (!question.advancedOptions.array_filter &&
                !question.advancedOptions.array_filter_reverse) ||
              (name === answerTypes.answers &&
                questionsConfig[type].hasAnswer &&
                questionsConfig[type].hasSubQuestion)
            ),
          }"
        >
          {{
            name === answerTypes.answers
              ? parseTranslation(ANSWERS)
              : parseTranslation(SUB_QUESTIONS)
          }}
        </p>
        <span
          v-if="
            (!question.advancedOptions.array_filter &&
              !question.advancedOptions.array_filter_reverse) ||
              (name === answerTypes.answers &&
                questionsConfig[type].hasAnswer &&
                questionsConfig[type].hasSubQuestion)
          "
          :class="{ active: collapseAlternatives }"
        >
          <Arrow />
        </span>
      </button>
      <div class="collapsePanel" v-if="collapseAlternatives">
        <div
          v-if="
            (!question.advancedOptions.array_filter &&
              !question.advancedOptions.array_filter_reverse) ||
              (name === answerTypes.answers &&
                questionsConfig[type].hasAnswer &&
                questionsConfig[type].hasSubQuestion)
          "
        >
          <div v-if="!locked" class="orderBy">
            <button @click="e => changeCode(e, letterChangeCode)">
              {{ parseTranslation(ALPHABET) }}
            </button>
            <button class="active" @click="e => changeCode(e, numberChangeCode)">
              {{ parseTranslation(NUMBER) }}
            </button>
            <button
              v-if="checkAlternativeConfig('hasFixedRandom')"
              :class="{ active: random }"
              @click="random = !random"
            >
              {{ parseTranslation(RANDOM) }}
            </button>
            <button
              v-if="checkAlternativeConfig('hasPrefixSuffix')"
              :class="{ active: prefixSuffixOn }"
              @click="togglePrefixSuffix()"
            >
              {{ parseTranslation(PREFIX_SUFFIX) }}
            </button>
          </div>
          <div v-for="(answer, index) in alternatives" :key="index">
            <div class="answer">
              <div class="up-down" v-if="!locked">
                <button @click="() => answerUp(index)"><Arrow /></button>
                <button @click="() => answerDown(index)"><Arrow /></button>
              </div>
              <input
                :class="{
                  'red-text': hasDuplicates(alternatives.map(answer => answer.code)),
                }"
                class="code"
                type="text"
                name="code"
                :disabled="locked"
                v-model="answer.code"
                @change="updateAlternatives(alternatives)"
              />

              <input
                class="prefix-suffix"
                type="text"
                name="prefix"
                :disabled="locked"
                :placeholder="parseTranslation(PREFIX)"
                maxlength="10"
                v-if="prefixSuffixOn"
                :value="answer.prefix || ''"
                @change="event => updatePrefixSuffix(event.target, index)"
              />

              <input
                :class="{
                  'red-text': hasDuplicates(alternatives.map(answer => answer.label)),
                  'label-input': true,
                }"
                type="text"
                name="label"
                :disabled="locked"
                v-model="answer.label"
                @change="updateAlternatives(alternatives)"
              />

              <input
                class="prefix-suffix"
                type="text"
                name="suffix"
                :placeholder="parseTranslation(SUFFIX)"
                :disabled="locked"
                v-if="prefixSuffixOn"
                :value="answer.suffix || ''"
                @change="event => updatePrefixSuffix(event.target, index)"
              />

              <media-preview
                class="media-preview"
                v-if="checkAlternativeConfig('hasMedia') && !locked"
                :question="question"
                :answer="answer"
                :alternativeName="name"
                :mediaId="`${question.qid}-${answer.code}-${name}`"
                :code="question.code"
                :saveSurvey="saveSurvey"
              />

              <div v-if="checkAlternativeConfig('hasExclusive')" class="fix-random">
                <input
                  class="input-exclusive"
                  type="checkbox"
                  :name="`${type}-${groupIndex}-${questionIndex}-${index}-exclusive`"
                  :id="`${type}-${groupIndex}-${questionIndex}-${index}-exclusive`"
                  v-model="answer.exclusive"
                  @change="updateAlternatives(alternatives)"
                  :disabled="locked"
                />
                <label
                  :for="`${type}-${groupIndex}-${questionIndex}-${index}-exclusive`"
                  >{{ parseTranslation(EXCLUSIVE) }}</label
                >
              </div>

              <div v-if="checkAlternativeConfig('hasUserInput')" class="fix-random">
                <input
                  class="user-input-check"
                  type="checkbox"
                  :name="`${type}-${groupIndex}-${questionIndex}-${index}-user-input`"
                  :id="`${type}-${groupIndex}-${questionIndex}-${index}-user-input`"
                  :checked="answer.userInput || false"
                  @change="() => handeUserInputToggle(index)"
                  :disabled="locked"
                />
                <label
                  :for="`${type}-${groupIndex}-${questionIndex}-${index}-user-input`"
                  >{{ parseTranslation(USER_INPUT) }}</label
                >
              </div>

              <div
                v-if="checkAlternativeConfig('hasFixedRandom') && random"
                class="fix-random"
              >
                <input
                  type="checkbox"
                  :name="`${type}-${groupIndex}-${questionIndex}-${index}-fix-random`"
                  :id="`${type}-${groupIndex}-${questionIndex}-${index}-fix-random`"
                  v-model="answer.fix_random"
                  @change="updateAlternatives(alternatives)"
                />
                <label
                  :for="`${type}-${groupIndex}-${questionIndex}-${index}-fix-random`"
                  >{{ parseTranslation(FIXED) }}</label
                >
              </div>

              <AlternativeExtraOptions
                :updateAlternative="updated => updateSingleAlternative(updated, index)"
                :alternative="answer"
                :questions_groups_index="groupIndex"
                :question_index="questionIndex"
                :id="`${groupIndex}-${questionIndex}-${index}-alternative-extras`"
                :property="name"
              />

              <button v-if="!locked" class="remove" @click="openRemoveModal(index)">
                <Close />
              </button>
            </div>

            <FormulaRenderer
              v-if="checkAlternativeConfig('hasFormula')"
              :updateAlternative="updated => updateSingleAlternative(updated, index)"
              :questions_groups_index="groupIndex"
              :alternative="answer"
              :question_index="questionIndex"
              :id="`${groupIndex}-${questionIndex}-${index}`"
            />
          </div>

          <div class="buttons">
            <button v-if="!locked" @click="addNew(alternatives.length)">
              <span class="plus-sign"> + </span>

              <span
                >{{ parseTranslation(ADD) }}
                {{
                  name === answerTypes.answers
                    ? parseTranslation(ANSWER)
                    : parseTranslation(SUB_QUESTION)
                }}</span
              >
            </button>

            <button class="add-in-bulk" @click="toggleDisplayModalAddOrEditInBulk">
              <span class="plus-sign"> + </span>

              {{ parseTranslation(BULK_ADD_OR_EDIT) }}
            </button>

            <Portal
              :to="PORTAL_NAMES.MODAL_DEFAULT"
              v-if="ShouldDisplayModalAddOrEditInBulk"
            >
              <BulkAddAndEditModal
                :alternatives="alternatives"
                :toggleDisplayModalAddOrEditInBulk="toggleDisplayModalAddOrEditInBulk"
                :updateAlternatives="updateAlternatives"
              />
            </Portal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import MediaPreview from '../MediaPreview.vue'

import FormulaRenderer from './FormulaRenderer.vue'
import AlternativeExtraOptions from './AdvancedOptions'

import Arrow from '@/components/imgs/ArrowExpandGroup'
import Close from '@/components/imgs/Close'

import { questionsConfig } from '@/utils/questions'
import { getLastIndex } from '@/utils/array'
import { QUESTION_TYPES, ANSWER_TYPES, PORTAL_NAMES } from '@/utils/constants'

import * as translationIndex from './index.translations'

import BulkAddAndEditModal from '@/pages/Scheme/Alternatives/BulkAddAndEditModal'

const { default: translations, ...translationKeys } = translationIndex

export default {
  name: 'Alternatives',

  props: {
    name: { type: String, required: true },
    questionIndex: { type: Number, required: true },
    groupIndex: {
      type: Number,
      required: true,
    },
    expandAll: { required: false },
    locked: {
      default: false,
    },
    saveSurvey: {
      required: true,
    },
  },

  components: {
    MediaPreview,
    FormulaRenderer,
    BulkAddAndEditModal,
    Arrow,
    Close,
    AlternativeExtraOptions,
  },

  data() {
    return {
      translations,
      ...translationKeys,
      questionsConfig,
      questionTypes: QUESTION_TYPES,
      answerTypes: ANSWER_TYPES,
      temp: 0,
      codeType: 'number',
      letterChangeCode: 'letter',
      numberChangeCode: 'number',
      baseNum: 'a'.charCodeAt(0) - 1,
      random: false,
      prefixSuffixOn: false,
      showParam: false,
      conditions: [],
      alternatives: [],
      typeHelp: {
        number: {
          change: val => val.charCodeAt(0) - this.baseNum,
          recode: val => val,
          regTest: /^[a-z]*$/,
        },
        letter: {
          change: val => String.fromCharCode(this.baseNum + parseInt(val)),
          recode: val => String.fromCharCode(this.baseNum + val),
          regTest: /^\d*$/,
        },
      },
      collapseAlternatives: false,
      ShouldDisplayModalAddOrEditInBulk: false,
      PORTAL_NAMES,
    }
  },
  computed: {
    ...mapState(['questionGroups']),

    ...mapGetters(['mediaObj', 'deleteMedia', 'darkmode']),

    question() {
      return this.questionGroups[this.groupIndex].questions[this.questionIndex]
    },

    type() {
      return this.question.type
    },

    alternativesConfig() {
      const alternativeProp =
        this.name === this.answerTypes.answers ? 'answerConfig' : 'subQuestionConfig'

      return alternativeProp
    },
  },
  watch: {
    deleteMedia() {
      if (
        this.deleteMedia?.answer &&
        this.deleteMedia?.qid === this.question.qid &&
        this.deleteMedia?.alternativeName === this.name
      ) {
        this.alternatives = this.alternatives.map(alternative => {
          if (alternative.code === this.deleteMedia.answer.code) {
            alternative.media = null
          }
          return alternative
        })
      }
    },

    mediaObj() {
      if (
        this.mediaObj?.answer &&
        this.mediaObj?.qid === this.question.qid &&
        this.mediaObj?.alternativeName === this.name
      ) {
        this.alternatives = this.alternatives.map(alternative => {
          if (alternative.code === this.mediaObj.answer.code) {
            alternative.media = {
              width: this.mediaObj.width,
              height: this.mediaObj.height,
              type: this.mediaObj.type,
              url: this.mediaObj.url,
              showLabel: this.mediaObj.showLabel || false,
            }
          }
          return alternative
        })
      }
    },

    random() {
      if (!this.random) this.removeFixedRandomReferences()

      const randomAdvancedOption = this.determineRandomAdvancedOptionToToggle()

      this.changeAdvanced({
        questionGroupIndex: this.groupIndex,
        questionIndex: this.questionIndex,
        advancedKey: randomAdvancedOption,
        value: this.random,
      })
    },

    alternatives() {
      this.validateCode()
      this.validateText()
    },

    type() {
      this.random = false
      this.removeFixedRandomReferences()
    },

    expandAll() {
      this.collapseAlternatives = !!this.expandAll
    },
  },

  methods: {
    ...mapActions([
      'modalBtns',
      'changeFlow',
      'changeSpecificQuestionProperty',
      'changeAdvanced',
      'setBulkAddAndEditModal',
    ]),

    getAlternatives() {
      this.alternatives =
        this.name === this.answerTypes.answers
          ? this.question.answers
          : this.question.subQuestions
    },

    toggleDisplayModalAddOrEditInBulk() {
      this.ShouldDisplayModalAddOrEditInBulk = !this.ShouldDisplayModalAddOrEditInBulk
    },

    determineRandomAdvancedOptionToToggle() {
      const currentConfig = questionsConfig[this.type]

      const [hasAnswer, hasSubQuestion] = ['hasAnswer', 'hasSubQuestion'].map(
        configProp => currentConfig[configProp],
      )

      if (!hasAnswer || !hasSubQuestion) return 'random_order'

      const isAnswer = this.name === this.answerTypes.answers

      /*
        The default behavior of random is to tackle on subQuestions if present.
        However, in cases we can have both dimensions randomized, randomization of
        our answers is handled by the multi_alternative_random option, while random_order
        continues to behave as subQuestion indicative
      */
      return isAnswer ? 'multi_alternative_random' : 'random_order'
    },

    removeFixedRandomReferences() {
      this.alternatives = this.alternatives.map(alternative => ({
        ...alternative,
        fix_random: false,
      }))
    },

    checkAlternativeConfig(config) {
      return questionsConfig[this.type][this.alternativesConfig][config]
    },

    updateAlternatives(updatedAlternatives) {
      this.alternatives = updatedAlternatives

      this.changeSpecificQuestionProperty({
        questionGroupIndex: this.groupIndex,
        questionIndex: this.questionIndex,
        property: this.name === this.answerTypes.answers ? 'answers' : 'subQuestions',
        value: updatedAlternatives,
      })
    },

    updateSingleAlternative(newInfo, updateIndex) {
      this.alternatives = this.alternatives.map((alternative, alternativeIndex) =>
        alternativeIndex === updateIndex ? newInfo : alternative,
      )

      this.changeSpecificQuestionProperty({
        questionGroupIndex: this.groupIndex,
        questionIndex: this.questionIndex,
        property: this.name === this.answerTypes.answers ? 'answers' : 'subQuestions',
        value: this.alternatives,
      })
    },

    changeCode(e, to) {
      const btnArray = [...e.target.parentElement.children]
      btnArray.forEach(btn => btn.classList.remove('active'))
      e.target.classList.add('active')

      if (this.typeHelp[to] !== undefined) this.codeType = to
      else return

      for (let i = 0; i < this.alternatives.length; i++) {
        if (this.typeHelp[to].regTest.test(this.alternatives[i].code))
          this.alternatives[i].code = this.typeHelp[to].change(this.alternatives[i].code)
      }

      this.updateAlternatives(this.alternatives)
    },

    recode() {
      const updatedAlternatives = this.alternatives.map(
        ({ code, ...alternative }, index) => ({
          ...alternative,
          code: this.typeHelp[this.codeType].recode(index + 1),
        }),
      )

      this.updateAlternatives(updatedAlternatives)
    },

    reArrangeAnswerByIndex(answerIndex, direction) {
      const updated = [...this.alternatives]

      const [toMoveAnswer] = updated.splice(answerIndex, 1)

      const newIndex = direction === 'up' ? answerIndex - 1 : answerIndex + 1

      updated.splice(newIndex, 0, toMoveAnswer)

      return updated
    },

    answerUp(index) {
      if (!index) return

      const updated = this.reArrangeAnswerByIndex(index, 'up')

      this.updateAlternatives(updated)
      this.recode()
    },

    answerDown(index) {
      if (index === getLastIndex(this.alternatives)) return

      const updated = this.reArrangeAnswerByIndex(index, 'down')

      this.updateAlternatives(updated)
      this.recode()
    },

    addNew(index) {
      const newAlternatives = [
        ...this.alternatives,
        {
          code: index + 1,
          label: `NO LABEL ${index + 1}`,
        },
      ]

      this.updateAlternatives(newAlternatives)
    },

    /* ***********************************************************************************************************************************************************
     ** Currently, question/group logic is in a string-expression format.
     ** For example: Q0.1.1 AND Q1.1
     ** We need to verify if we have an existing reference on it
     ** On formula questions, it is straight forward
     ** BECAUSE we are changing this format in the near future,
     ** we will keep this obscure implementation until a proper refactor
     ** can take place
     */
    extractLogicReferences(logic) {
      const SPACER = '@'

      const formatted = logic.replace(' AND ', SPACER).replace(' OR ', SPACER)

      const references = formatted.split(SPACER)

      return references
    },

    getLogicSplitIndexToCheck() {
      const { hasAnswer, hasSubQuestion } = questionsConfig[this.type]

      const hasBothAlternatives = hasAnswer && hasSubQuestion

      const hasBothIndex = this.name === this.answerTypes.answers ? 2 : 1

      const splitIndexToCheck = hasBothAlternatives ? hasBothIndex : 1

      return splitIndexToCheck
    },

    verifyIfAlternativeIsReferencedInLogic(logic, alternativeCode) {
      if (!logic) return false

      const splitIndexToCheck = this.getLogicSplitIndexToCheck()

      const questionReferences = this.extractLogicReferences(logic)

      const hasReference = questionReferences.some(reference => {
        const referenceParts = reference.split('.')

        const referencedAlternative = referenceParts[splitIndexToCheck]

        if (referencedAlternative !== `${alternativeCode}`) return false

        const [questionCode] = referenceParts

        return questionCode === `${this.question.code}`
      })

      return hasReference
    },

    checkReferenceInGroupLogic(alternativeCode) {
      const groupConditions = this.questionGroups[this.groupIndex]?.logic?.conditions

      const isReferenced = groupConditions?.some(({ logic }) =>
        this.verifyIfAlternativeIsReferencedInLogic(logic, alternativeCode),
      )

      return isReferenced
    },

    checkReferenceInQuestionLogic(alternativeCode) {
      const questionsToCheck = this.questionGroups[this.groupIndex].questions.filter(
        (_, index) => index >= this.questionIndex,
      )

      const isReferenced = questionsToCheck.some(({ logic }) =>
        logic.conditions.some(condition =>
          this.verifyIfAlternativeIsReferencedInLogic(condition.logic, alternativeCode),
        ),
      )

      return isReferenced
    },

    verifyConditionsReferenceExistence(conditions, alternativeCode) {
      const alternativeKey =
        this.name === this.answerTypes.answers ? 'answer' : 'subQuestion'

      const anyConditionRef = conditions?.some(({ questionRef }) => {
        const sameQuestion = this.question.qid === questionRef.id

        const sameAlternativeCode =
          `${questionRef[alternativeKey]}` === `${alternativeCode}`

        return sameQuestion && sameAlternativeCode
      })

      return anyConditionRef
    },

    verifyIfIsReferencedInAnyAnswerCondition(answers, alternativeCode) {
      const isReferenced = answers.some(({ conditions }) =>
        this.verifyConditionsReferenceExistence(conditions, alternativeCode),
      )

      return isReferenced
    },

    checkReferenceInFormulaQuestion(alternativeCode) {
      const questionsToCheck = this.questionGroups[this.groupIndex].questions.filter(
        ({ type }, index) =>
          index >= this.questionIndex && type === QUESTION_TYPES.formula,
      )

      const isReferenced = questionsToCheck.some(({ answers }) =>
        this.verifyIfIsReferencedInAnyAnswerCondition(answers, alternativeCode),
      )

      return isReferenced
    },

    hasLogic(index) {
      const alternativeCode = this.alternatives[index].code

      const hasReference = [
        this.checkReferenceInGroupLogic.bind(this),
        this.checkReferenceInQuestionLogic.bind(this),
        this.checkReferenceInFormulaQuestion.bind(this),
      ].some(callback => callback(alternativeCode))

      return hasReference
    },

    togglePrefixSuffix() {
      if (!this.prefixSuffixOn) return (this.prefixSuffixOn = true)

      const remainingAlternatives = this.alternatives.map(
        ({ prefix, suffix, ...alternative }) => alternative,
      )

      this.updateAlternatives(remainingAlternatives)
      this.prefixSuffixOn = false
    },

    handlePrefixSuffixAlternativeUpdate(property, value, alternative) {
      if (value) return { ...alternative, [property]: value }

      const toUpdate = { ...alternative }

      delete toUpdate[property]

      return toUpdate
    },

    updatePrefixSuffix({ name, value }, alternativeIndex) {
      const updated = this.alternatives.map((alternative, index) =>
        alternativeIndex === index
          ? this.handlePrefixSuffixAlternativeUpdate(name, value, alternative)
          : alternative,
      )

      this.updateAlternatives(updated)
    },

    /************************************************************************************************************************************************************************************************/

    openRemoveModal(index) {
      const currentAlternative =
        this.name === this.answerTypes.answers
          ? this.parseTranslation(this.ANSWER)
          : this.parseTranslation(this.SUB_QUESTION)

      if (!this.hasLogic(index)) return this.remove({ index })

      this.modalBtns({
        text: this.parseTranslation(
          this.MODAL_TEXT_REMOVE_ALTERNATIVE,
          currentAlternative,
        ),
        yes: this.remove,
        params: { index },
      })
    },

    remove({ index: toRemoveIndex }) {
      const remainingAlternatives = this.alternatives.filter(
        (_, index) => index !== toRemoveIndex,
      )

      this.updateAlternatives(remainingAlternatives)
    },

    changeFlow() {
      this.changeFlow(!this.$store.getters.changeFlow)
    },

    hasDuplicates(codeOrLabelArray) {
      const noDuplicateArray = Array.from(new Set(codeOrLabelArray))

      return noDuplicateArray.length !== codeOrLabelArray.length
    },

    handeUserInputToggle(index) {
      const updatedAlternatives = this.alternatives.map((alternative, alternativeIndex) =>
        index === alternativeIndex
          ? {
              ...alternative,
              userInput: !alternative.userInput,
            }
          : alternative,
      )

      this.updateAlternatives(updatedAlternatives)
    },

    validateText() {
      const regexp = /[\\]/g

      this.alternatives.forEach(alternative => {
        if (alternative.label.toString().match(regexp)) {
          alternative.label = alternative.label.toString().replace(regexp, '')
        }
      })

      this.updateAlternatives(this.alternatives)
    },

    validateCode() {
      const regexp = /[\W_]/g

      this.alternatives.forEach(alternative => {
        if (alternative.code.toString().match(regexp)) {
          alternative.code = alternative.code.toString().replace(regexp, '')
        }
        if (!isNaN(alternative.code) && alternative.code !== '')
          alternative.code = +alternative.code
      })

      this.updateAlternatives(this.alternatives)
    },

    collapse() {
      this.collapseAlternatives = !this.collapseAlternatives
    },
  },

  created() {
    this.getAlternatives()

    const randomProp = this.determineRandomAdvancedOptionToToggle()

    this.random = this.question.advancedOptions[randomProp] || false

    this.prefixSuffixOn = this.alternatives.some(
      ({ prefix, suffix }) => !!(prefix || suffix),
    )
  },
}
</script>

<style lang="scss" scoped>
.expandPanel {
  @include flexAlignCenter;
  padding: 10px 0;
  border: none;
  width: 100%;
  cursor: pointer;
  font-size: inherit;
  background: none;

  &:focus {
    outline: none;
  }

  p {
    @include tipography(16);
    font-weight: bold;
    white-space: nowrap;
  }

  span {
    @include flexAlignCenter;
    svg {
      @include boxSizing(15);
    }

    margin-left: 10px;
    transition: all 0.3s ease-in;
    transform: rotate(180deg);

    &.active {
      transform: rotate(0);
    }
  }

  &::after,
  &::before {
    content: '';
    display: block;
    width: 40px;
    height: 1px;
    background: $white;
    margin: 0 10px 0 0;
  }
  &::after {
    width: 100%;
    margin: 0 0 0 10px;
  }

  .changeExpand {
    color: #8d8c8c;
  }

  .light & {
    p {
      color: $gray-6;
    }

    &::after,
    &::before {
      background: $gray-5;
    }

    .changeExpand {
      color: #8d8c8c;
    }
  }
}

input[type='text'][disabled].light {
  background: rgb(233, 233, 233);
}

.prefix-suffix {
  width: 90px;
  max-width: 90px;
  flex: 0 0 90px;

  &::placeholder {
    font-style: italic;
  }
}

.collapsePanel {
  animation: growDown 400ms ease-in-out forwards;
  transform-origin: top center;

  &:nth-of-type(2) {
    padding-left: 30px;
  }

  &.active,
  &.expandAll {
    display: block;
  }

  .answer {
    position: relative;
    @include flexAlignCenter;

    padding: 10px 30px;

    input {
      display: block;
      background: none;
      border: 1px solid $gray-9;
      border-radius: 3px;
      padding: 6px 5px;
      margin: 0 8px;
      &:first-of-type {
        margin: 0 8px 0 0;
      }
      @include tipography(16);

      &:nth-of-type(1) {
        max-width: 60px;
      }
      &.label-input {
        flex: 1;
      }
    }

    .remove,
    .up-down {
      position: absolute;
      right: 0;
      display: none;
      width: 30px;
    }

    .remove {
      cursor: pointer;
      svg {
        @include boxSizing(15);
      }

      background: transparent;
      border: none;
      outline: none;
    }

    .up-down {
      right: unset;
      left: 0;
      padding: 10px 0;

      button {
        display: block;
        cursor: pointer;
        @include transparentButton;

        svg {
          @include boxSizing(15);
        }

        &:nth-of-type(2) {
          svg {
            transform: rotate(180deg);
          }
        }
      }
    }

    .fix-random {
      @include flexAlignCenter;

      margin: 0 10px;
      @include tipography(12);
      animation: slideIn 0.3s;

      .light & {
        color: $gray-6;
      }

      input {
        background: none;
      }
    }
    &:hover {
      background: rgba(255, 255, 255, 0.1);
      .remove {
        display: flex;
        justify-content: center;
      }
      .up-down {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }

    .light & {
      input {
        color: $gray-6;
        &:focus {
          outline: none;
          border: 1px solid $gray-8;
        }
      }

      &:hover {
        background: rgba(0, 0, 0, 0.1);
      }
    }
  }
}
.orderBy {
  display: flex;
  margin: 10px 0 10px 30px;
  button {
    @include tipography(12px);
    @include flexAlignCenter;
    cursor: pointer;
    position: relative;
    z-index: 2;
    margin-right: 10px;
    background: none;
    border: none;

    &::before {
      content: '';
      display: block;
      @include boxSizing(8);

      border-radius: 1px;
      box-shadow: 0 0 0 2px $gray-8, 0 0 0 3px $white;
      margin: 0 10px 0 3px;
      transition: all 0.5s ease;
      background: $gray-8;
    }
    &:nth-of-type(3) {
      margin-left: auto;
      margin-right: 30px;
    }
    &:hover {
      &::before {
        background: $gray;
      }
    }
    &.active {
      &::before {
        background: $blue;
      }
    }
    &:focus {
      outline: none;
    }
  }
  input {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    opacity: 0;
  }
  .light & {
    button {
      color: $gray-9;
      &::before {
        background: $white;
        box-shadow: 0 0 0 2px $white, 0 0 0 3px $gray-9;
      }
      &:hover {
        &::before {
          background: $gray;
        }
      }
      &.active {
        &::before {
          background: $blue;
        }
      }
    }
  }
}

.add-alternative-btn {
  @include transparentButton;
  @include tipography(16);
  color: $blue;
  margin: 15px 0 15px 30px;

  .plus-sign {
    @include flexMiddle;
    @include boxSizing(20);
    box-sizing: border-box;

    color: $white;
    margin-right: 12px;
    background: $blue;
    font-size: 25px;
    border-radius: 50%;
  }
}

.next-question {
  margin-bottom: 20px;
  label {
    @include tipography(16);
  }
  .light & {
    label {
      color: $gray-6;
    }
  }
}
.select {
  background: linear-gradient(180deg, #3f3f40 0%, #212122 48.96%, #3f3f40 98.96%);
  border: 1px solid $gray-9;
  border-radius: 3px;
  padding: 2px 5px;
  @include tipography(16);
  margin-right: 15px;
  option {
    color: $gray-2;
  }
  &:focus {
    outline: none;
    border: 1px solid $white;
  }
  &.and-or {
    margin-left: 60px;
  }
  &.next {
    margin-left: 10px;
  }
  .light & {
    background: linear-gradient(180deg, #ffffff 0%, #edebeb 48.96%, #ffffff 98.96%);
    color: $gray-6;
    &:focus {
      outline: none;
      border: 1px solid $gray-8;
    }
  }
}
.no-condition {
  border-top: 1px solid $white;
  padding: 20px 0;
  @include tipography(14);
  .light & {
    color: $gray-6;
    border-top: 1px solid $gray-5;
  }
}
.condition-wrapper {
  border-top: 1px solid $white;
  padding: 20px 0;
  .light & {
    border-top: 1px solid $gray-5;
  }
}
.condition {
  @include flexAlignCenter;
  @include tipography(16);
  padding: 0 0 10px;

  a {
    cursor: pointer;
  }

  p {
    margin-right: 10px;
  }

  .light & {
    color: $gray-6;
  }
}

.to {
  @include flexAlignCenter;
}

.buttons {
  @include flexAlignCenter;

  button {
    @include transparentButton;
    @include tipography(16);
    color: $blue;
    margin: 10px 0 10px 30px;

    .plus-sign {
      @include flexMiddle;
      @include boxSizing(20);
      box-sizing: border-box;

      color: $white;
      margin-right: 12px;
      background: $blue;
      font-size: 25px;
      border-radius: 50%;
    }
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    margin-right: 30px;
  }
  to {
    opacity: 1;
    margin-right: 10px;
  }
}

.red-text {
  color: red !important;
}

@media (max-width: 576.98px) {
  .orderBy {
    justify-content: center;
    margin: 10px 0;

    button {
      margin-right: 10px;
      display: block;
      &:nth-of-type(3) {
        margin: 0;
      }
      &::before {
        position: relative;
        left: calc(50% - 4px);
        margin-bottom: 5px;
      }
    }
  }

  .collapsePanel {
    .answer {
      flex-wrap: wrap;
      @include flexAlignCenter;
      padding: 10px 40px;

      input {
        margin: 10px 8px;
      }
    }
  }
}
</style>
